// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"g6-z"};